<template>
  <nav
    id="nav"
    class="navbar is-fixed-top is-black is-transparent"
    role="navigation"
    aria-label="dropdown navigation"
  >
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">
        <img :src="logoUrl" alt />
      </router-link>
    </div>
    <div class="navbar-menu">
      <div class="navbar-start">
        <div class="navbar-item">
          <span class="tag">{{ $t('navbar.title') }}</span>
        </div>
      </div>
      <div class="navbar-center" v-if="isLoggedIn && $route.params.appId">
        <apps-dropdown />
      </div>
      <div class="navbar-end" v-if="isLoggedIn">
        <account-dropdown />
      </div>
      <div class="navbar-end" v-if="!isLoggedIn">
        <div class="navbar-item">
          <language-switcher></language-switcher>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { isLoggedIn } from 'router/helpers';
import router from 'router/index';
import AccountDropdown from './AccountDropdown';
import AppsDropdown from './AppsDropdown';
import LanguageSwitcher from './LanguageSwitcher';
import { configs } from 'config';

export default {
  components: {
    AccountDropdown,
    AppsDropdown,
    LanguageSwitcher,
  },

  data() {
    return {
      logoUrl: configs().LOGO_URL,
    };
  },

  computed: {
    isLoggedIn() {
      return isLoggedIn();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.navbar {
  padding-left: 2rem;
  padding-right: 2rem;
  // background-image: linear-gradient(120deg, rgba(48, 35, 174, .1), rgba(200,	109, 215, .1));
}

.navbar-brand {
  .navbar-item {
    img {
      max-height: 1.625rem;
    }
  }
}

.navbar-link,
.tag {
  font-size: 0.75rem;
  text-transform: uppercase;
}

.navbar-link {
  letter-spacing: 0.25rem;
}

.tag {
  background-color: transparent;
  border: solid 1px rgba($white, 0.32);
  border-radius: 0.125rem;
  color: $white;
  letter-spacing: 0.21875rem;
}
</style>

<style lang="scss">
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

#nav {
  .language-switcher {
    .button {
      background-color: transparent;
      border-color: transparent;
      color: $white;
    }

    .dropdown-menu {
      margin-top: 12px;
    }
  }
}
</style>
